import type { DragEvent, FC } from 'react';
import IconMdi from '@components/IconMdi';
import { Spinner } from '@components/Spinner';
import { mdiClose } from '@mdi/js';

interface DocxDropZoneProps {
  isConverting: boolean;
  onClose: () => void;
  onFilesDropped: (files: FileList) => void;
  onUploadClick: () => void;
}

export const DocxDropZone: FC<DocxDropZoneProps> = ({ isConverting, onClose, onFilesDropped, onUploadClick }) => {
  const handleDrop = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer.files.length > 0) {
      onFilesDropped(event.dataTransfer.files);
    }
  };

  return (
    <div
      className="bg-info-50 absolute inset-0 z-10 flex flex-col"
      data-testid="docx-drop-zone"
      onDragOver={(event) => event.preventDefault()}
      onDrop={handleDrop}
    >
      <div className="flex h-11 justify-end pt-3 pr-3">
        {!isConverting && (
          <button
            aria-label="Close import"
            className="text-info-600 hover:text-info-800"
            onClick={onClose}
            type="button"
          >
            <IconMdi path={mdiClose} size={0.85} />
          </button>
        )}
      </div>
      <div className="flex flex-1 items-center justify-center pb-8">
        <div className="border-info-300 flex w-[500px] max-w-full flex-col items-center gap-1 rounded-md border-2 border-dashed bg-white p-[26px] text-center">
          {isConverting ? (
            <>
              <Spinner className="[&>path]:fill-primary-600" size="xs" />
              <p className="text-info-600 text-sm leading-5 font-medium">Importing file content...</p>
            </>
          ) : (
            <>
              <p className="text-info-600 text-sm leading-5 font-medium">
                <button className="text-primary-600 hover:underline" onClick={onUploadClick} type="button">
                  Upload a file
                </button>{' '}
                or drag and drop to import its content here
              </p>
              <p className="text-info-500 text-xs leading-4 font-normal">DOCX only, up to 10MB</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
